import { Flex, Text } from '@mantine/core';
import { LONG_DASH } from '@dealstack/frontend/shared/other/react/specialSigns.tsx';
import { ReactNode } from 'react';

interface Props {
	label: string;
	value?: ReactNode;
}

export const DetailField = ({ label, value }: Props) => (
	<Flex direction="column" gap="0.25rem" miw={0}>
		<Text size="sm" c="dark.0">
			{label}
		</Text>
		{/* A div, not Text's default <p>: a value can be a node (the country carries a flag),
		    and a <div> inside a <p> is invalid nesting React warns about. */}
		<Text size="sm" fw={600} c="dark.8" component="div" style={{ wordBreak: 'break-word' }}>
			{value || LONG_DASH}
		</Text>
	</Flex>
);
